import { BusinessOwnerData } from "../BusinessControls/RenderBusinessOwnerName";

export interface AvailabilitySlot {
    startTime: string;
    endTime: string;
    serviceId: string;
    staffId: string;
}

export interface RealTimeAvailabilityPro extends BusinessOwnerData {
    availability?: AvailabilitySlot[] | null;
}

export interface DirectorySearchState {
    searchText: string;
    serviceText: string;
    selectedDate: Date | null;
    selectedTime: string | null;
    bTypeFilter: string[];
}

export interface SubFacility {
    id: string;
    header: string;
    value: string;
}

export interface FacilityCategory {
    id: string;
    header: string;
    categoryName: string;
    order: number;
    SubFacilities: SubFacility[];
}

export interface TimeOption {
    label: string;
    value: string;
}

export const generateTimeSlots = (): TimeOption[] => {
    const slots: TimeOption[] = [{ label: "Anytime", value: "" }];
    for (let hour = 0; hour < 24; hour++) {
        for (let min = 0; min < 60; min += 30) {
            const h = hour % 12 || 12;
            const ampm = hour < 12 ? "AM" : "PM";
            const label = `${h}:${min.toString().padStart(2, "0")} ${ampm}`;
            const value = `${hour.toString().padStart(2, "0")}:${min.toString().padStart(2, "0")}`;
            slots.push({ label, value });
        }
    }
    return slots;
};
